export default [
  // {
  //   title: "Custom Report",
  //   customIcon: "CustomSVG",
  //   children: [
  //     {
  //       title: "Reconcile",
  //       route: "custom-module",
  //       path: "/custom-module/report-reconcile",
  //     },
  //   ],
  // },
  {
    title: "Manual Coupon",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Manual Coupon",
        route: "manual-coupon",
        path: "/custom-module/manual-coupon",
      },
    ],
  },
];
